module.exports = __webpack_public_path__ + "static/img/banner_mobile5.dbf8edf9.jpg";